<div class="row">
    <div class="col-12 col-md-6">
        <div class="table-container mat-elevation-z2">
            <div class="loading-shade"
                 *ngIf="isLoadingResults || error">
                <mat-spinner *ngIf="isLoadingResults"></mat-spinner>
                <div class="error" *ngIf="error">
                    An error has occurred, please try again later.
                </div>
            </div>

            <mat-table mat-table [dataSource]="dataSource" matSort>
                <ng-container matColumnDef="Name">
                    <mat-header-cell *matHeaderCellDef>Name</mat-header-cell>
                    <mat-cell *matCellDef="let element" data-label="Name">
                        {{element.name}}
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            </mat-table>
        </div>
    </div>
    <div class="col-12 col-md-6">
        <div class="mat-elevation-z2 panel">
            <div class="unselected">Permissions are readonly.</div>
        </div>
    </div>
</div>
